import { render, staticRenderFns } from "./userTable.vue?vue&type=template&id=f1fb85b6&scoped=true&"
import script from "./userTable.vue?vue&type=script&lang=js&"
export * from "./userTable.vue?vue&type=script&lang=js&"
import style0 from "./userTable.vue?vue&type=style&index=0&id=f1fb85b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1fb85b6",
  null
  
)

export default component.exports